import { AccountInterface, AccountKind, LoginDataInterface, MemberInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Account/Account.Controller.ts
export class AccountAPI {
  static async signUp(firstName: string, lastName: string, email: string, avatarURL: string, password: string, inviteUUID?: string) {
    return APIService.Server.post<AccountInterface>(`/account/sign-up`, {
      firstName,
      lastName,
      email,
      avatarURL,
      password,
      inviteUUID
    });
  }

  static async logIn(username: string, password: string) {
    return APIService.Server.post<LoginDataInterface>(`/account/log-in`, {
      username: username.toLowerCase(),
      password: password
    });
  }

  static async refreshMember(orgId: number, memberId: number) {
    return APIService.Server.get<MemberInterface>(`/account/org/${orgId}/member/${memberId}/refresh`);
  }

  static async updatePassword(accountId: number, currentPassword: string, newPassword: string) {
    return APIService.Server.put<AccountInterface>(`/account/update-password`, {
      accountId: accountId,
      currentPassword: currentPassword,
      newPassword: newPassword
    });
  }

  static async forgotPassword(email: string) {
    return APIService.Server.post(`/account/send-recovery-email`, {
      email: email
    });
  }
  static async resetPassword(token: string, password: string) {
    return APIService.Server.post<AccountInterface>(`/account/reset-password`, { token: token, password: password });
  }
  static async updateAccount(accountId: number, updates: { firstName?: string; lastName?: string; email?: string }) {
    return APIService.Server.put<AccountInterface>(`/account/update-profile`, {
      accountId,
      ...updates
    });
  }

  static async createAccountIfExistsInV2(username: string, password: string) {
    return APIService.Server.post<LoginDataInterface>(`/account/create-account-if-exists-in-v2`, {
      username: username.toLowerCase(),
      password: password
    });
  }

  static async searchAccounts(query: string) {
    return APIService.Server.get<AccountInterface[]>(`/account/search`, { query });
  }

  static async updateKind(accountId: number, kind: AccountKind) {
    return APIService.Server.patch<AccountInterface>(`/account/${accountId}/kind`, { kind });
  }
}
